import styled from 'styled-components';

import { fontWeight } from 'stylesheetB2b';

export const StyledRemainingTime = styled.span`
  font-weight: ${fontWeight.bold};
`;
StyledRemainingTime.displayName = 'StyledRemainingTime';
